<template>
    <div class="header-container justify-content-between">
        <img  class="logo header-style" :src="getSrc">
        <div :class="{'right-class': $i18n.locale === 'ar'}" class="buttons-container">
            <router-link v-if="isQueue && bookingAllowed" to="/booking">
                <button ref="rnvButton" id="rnvButton" :disabled="modelValue" :style="getBorderBookingStyle" class="btn rndvButton">
                    <div style="margin: auto"><img style="height: 4.3vh" src="../assets/icons/booking-icon.svg"/></div>
                <div :style="{'padding-left': $i18n.locale !== 'ar' ? '1vmin': '', 'padding-right': $i18n.locale === 'ar' ? '1vmin': ''}" class="button-label hide-on-mobile">{{ $t('Kiosk.rndvdButtonBook') }}</div>
            </button>
            </router-link>

            <router-link v-else-if="bookingAllowed" to="/waitingQueue">
                <button id="queueBtn" ref="queueBtn" :disabled="modelValue" :style="getBorderBookingStyle" class="btn rndvButton">
                <div style="margin: auto"> <img style="height: 4.3vh" src="../assets/icons/waiting-queue-button.svg"/></div>
                <div :style="{'padding-left': $i18n.locale !== 'ar' ? '1vmin': '', 'padding-right': $i18n.locale === 'ar' ? '1vmin': ''}" class="button-label hide-on-mobile">{{ $t('Kiosk.waitingQueueButton') }}</div>
            </button>
            </router-link>
            <button id="languageBtn" :disabled="modelValue" @click="showLanguagePopup = true" class="btn languageButton">
                <div style="margin: auto"> <img style="height: 4.3vh" src="../assets/icons/global-white.svg"/></div>
                <div :style="{'padding-left': $i18n.locale !== 'ar' ? '1vmin': '', 'padding-right': $i18n.locale === 'ar' ? '1vmin': ''}" class="button-label hide-on-mobile">{{ $t('Kiosk.languageTitle') }}</div>
            </button>
        </div>
        <LbrxLanguageSelectPopup v-if="showLanguagePopup" @close="showLanguagePopup = false" v-model="showLanguagePopup"></LbrxLanguageSelectPopup>
    </div>
</template>
<script>
import colorShader from "@/_helpers/color-shader";
import router from "@/router";
import LbrxLanguageSelectPopup from "@/components/LbrxLanguageSelectPopup.vue";
export default {
    name :'LbrxKioskHeader',
    components: {LbrxLanguageSelectPopup},
    props: {
        primaryColor: {required: true, type:String},
        secondaryColor: {required: true, type:String},
        hasBorderRadius: {required: true, type:Boolean},
        textColor: {required: true, type:String},
        headerBackground: {required: true, type:String},
        modelValue: {required: true, type: Boolean},
        logo: {required: true, type: String},
        themeTemplate: {required: false, type: Object, default: null},
    },
    data() {
      return {
          showLanguagePopup:false,
      }
    },
    computed: {
        getSrc() {
           return this.logo;
        },
        isQueue() {
          return this.$router.currentRoute._value.name === 'waitingQueue';
        },
        bookingAllowed() {
            return JSON.parse(window.localStorage.getItem('kiosk')).allow_booking;
        },
        getBorderBookingStyle() {
            if(this.themeTemplate) {
                if(this.themeTemplate.allowCategory == 1)
                    return '';
                else {
                    return {
                        borderRadius: this.hasBorderRadius && this.$i18n.locale !== 'ar' ? '0 0 0 10vmin' : this.hasBorderRadius && this.$i18n.locale === 'ar' ? '0 0 10vmin 0' :  '0', 'padding-left': this.hasBorderRadius && this.$i18n.locale !== 'ar' ? '5vmin' : '', 'padding-right': this.hasBorderRadius && this.$i18n.locale === 'ar' ? '5vmin' : ''
                    }
                }
            } else {
                return {
                    borderRadius: this.hasBorderRadius && this.$i18n.locale !== 'ar' ? '0 0 0 10vmin' : this.hasBorderRadius && this.$i18n.locale === 'ar' ? '0 0 10vmin 0' :  '0', 'padding-left': this.hasBorderRadius && this.$i18n.locale !== 'ar' ? '5vmin' : '', 'padding-right': this.hasBorderRadius && this.$i18n.locale === 'ar' ? '5vmin' : ''
                }
            }
            
        }
    }
}
</script>

<style scoped>

.header-style {
    height: 7vh!important;
}
.header-container {
    padding-top: 1.3vmin;
    padding-bottom: 1.3vmin;
    background: v-bind(headerBackground) !important;
    display: flex;
    width: 100%;
    height: 11vh;
    padding-right: 4vmin;
    align-items: center; /* Center items vertically */
}

.header-container .logo {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 4vmin;
    height: 7vh; /* Default height */
}

.header-container .buttons-container {
    width: auto;
    display: flex;
    justify-content: flex-end; /* Align buttons to the right */
    height: fit-content;
    margin-top: auto;
    margin-bottom: auto;
    gap: 1vmin; /* Add gap between buttons */
}

.languageButton {
    background: v-bind(primaryColor);
    width: auto;
    display: flex;
    border-radius: 0 !important;
    height: 8vh;
}

.rndvButton {
    background: v-bind(secondaryColor);
    width: auto;
    min-width: 170px;
    height: 8vh;
    display: flex;
}

.button-label {
    margin: auto;
    font-family: 'Exo 2', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 3vh;
    text-align: center;
    color: v-bind(textColor);
}

@media (max-width: 768px) {
    .header-style {
        height: 6vh!important;
    }
    .hide-on-mobile {
        display: none;
    }
    .rndvButton, .languageButton {
        justify-content: center; /* Center the icon */
    }
    .rndvButton {
    background: v-bind(secondaryColor);
    width: 60px;
    min-width: 60px;
    height: 8vh;
    display: flex;
}

.button-label {
    margin: auto;
    font-family: 'Exo 2', serif;
    font-style: normal;
    font-weight: 100;
    font-size: 2vh;
    text-align: center;
    color: v-bind(textColor);
}

    .header-container {
        height: auto; 
        padding: 1vmin; 
    }

    .header-container .logo {
        height: 5vh; 
        margin-left: 2vmin; 
    }

    .header-container .buttons-container {
        gap: 0.5vmin;
    }

    .rndvButton,
    .languageButton {
        height: 6vh; 
        min-width: 120px; 
    }

    .button-label {
        font-size: 2vh; 
    }
}
</style>